import ValueDeserializerInterface from "./ValueDeserializerInterface"
import { SerializedValueType } from "../../Model/Value/ValueInterface"
import ConstantValue from "../../Model/Value/ConstantValue"

export default class ConstantValueDeserializer implements ValueDeserializerInterface {
  public supports(payload: SerializedValueType): boolean {
    return payload.type === "constant"
  }

  public deserialize(payload: SerializedValueType): ConstantValue {
    return new ConstantValue(payload.payload.value, payload.payload.symbol)
  }
}
